export function maxValue(values: number[]) {
  const m = Math.max(...values);

  return isFinite(m) ? m : 0;
}
